import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Restart from '@/images/Restart.svg';
import styled from '@emotion/styled';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import RestoreOriginalConfirmationModal from './RestoreOriginalConfirmationModal';

const StyledButton = styled(Button)`
    font-size: 1.2rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
`;

function RestoreOriginal() {
    const { formState, getFieldState, watch } = useFormContext();
    const selectedTranslationId = watch('selectedTranslationId');
    const { isDirty } = getFieldState(`captionsByTranslationId.${selectedTranslationId}.sentences`, formState);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    function handleRestoreOriginal() {
        setConfirmationModalOpen(true);
    }

    return (
        <>
            <StyledButton variant="text" color="secondary" onClick={handleRestoreOriginal} disabled={!isDirty}>
                <MaskedIcon src={Restart} size="16px" />
                Restore original
            </StyledButton>
            <RestoreOriginalConfirmationModal
                open={confirmationModalOpen}
                onClose={() => {
                    setConfirmationModalOpen(false);
                }}
            />
        </>
    );
}

export default RestoreOriginal;
